import { render } from "./FriendsComponent.vue?vue&type=template&id=3e224237&scoped=true"
import script from "./FriendsComponent.vue?vue&type=script&lang=js"
export * from "./FriendsComponent.vue?vue&type=script&lang=js"

import "./FriendsComponent.vue?vue&type=style&index=0&id=3e224237&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e224237"]])

export default __exports__